import React from 'react'
import get from 'lodash.get'
import PropTypes from 'prop-types'

import Typography from 'components/atoms/Typography'
import ButtonOutline from 'components/atoms/ButtonOutline'
import LinkHandler from 'components/atoms/LinkHandler'

import './CardPlan.scss'

function CardPlan(props) {
  const url = get(props, 'footer.url')
  const cta = get(props, 'footer.cta')
  const stampImage = get(props, 'stamp.image')
  const stampAlt = get(props, 'stamp.alt')
  const alt = get(props, 'alt')
  const image = get(props, 'image')
  const title = get(props, 'title')
  const descriptions = get(props, 'descriptions')

  return (
    <LinkHandler to={url}>
      <div className="CardPlan card-plans">
        <div className="card-plan-header">
          <img className="plan-img" src={image} alt={alt} />
          {stampImage && <img className="plan-icon" src={stampImage} alt={stampAlt} />}
        </div>
        <div className="card-plan-body">
          <Typography variant="h3" component="h5" cssClass="card-plan-body-title">
            {title}
          </Typography>
          <ul>
            {Array.isArray(descriptions) &&
              descriptions.map((description, index) => (
                <li key={index}>
                  <Typography variant="p" component="p" color="grey-100" cssClass="max-line-2">
                    {description}
                  </Typography>
                </li>
              ))}
          </ul>
          <div className="card-plan-footer">
            <ButtonOutline text={cta} />
          </div>
        </div>
      </div>
    </LinkHandler>
  )
}

CardPlan.proPTypes = {
  alt: PropTypes.string,
  descriptions: PropTypes.string,
  footer: PropTypes.shape({ url: PropTypes.string, cta: PropTypes.func }),
  image: PropTypes.string,
  stamp: PropTypes.shape({ image: PropTypes.string, alt: PropTypes.func }),
  title: PropTypes.string,
}

export default CardPlan
